import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const LanguageSelection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLang');
    // Ensure the saved preference is valid before redirecting to avoid loops
    if (savedLang === 'en' || savedLang === 'es') {
      navigate(`/${savedLang}`, { replace: true });
    }
  }, [navigate]);

  const selectLanguage = (lang) => {
    localStorage.setItem('preferredLang', lang);
    navigate(`/${lang}`);
  };

  return (
    <div className="fixed inset-0 min-h-screen flex flex-col justify-center items-center relative text-white z-50">
      <div className="absolute inset-0 z-0 bg-slate-900">
        <img
          src="https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/4a6ea99184e24cad8b73065a5304879b.png"
          alt="Townhouse background"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-slate-900/80"></div>
      </div>
      
      <div className="relative z-10 flex flex-col items-center max-w-lg w-full px-6 text-center">
        <SafeIcon name="Globe" className="w-16 h-16 mb-8 text-brand-light opacity-90" />
        
        <h1 className="text-3xl md:text-4xl font-bold mb-2">Welcome</h1>
        <p className="text-lg text-slate-300 mb-8">Please select your preferred language</p>

        <h1 className="text-3xl md:text-4xl font-bold mb-2">Bienvenido</h1>
        <p className="text-lg text-slate-300 mb-12">Seleccione su idioma de preferencia</p>

        <div className="flex flex-col sm:flex-row gap-4 w-full justify-center mb-16">
          <button 
            onClick={() => selectLanguage('en')} 
            className="btn-primary text-xl px-10 py-4 w-full sm:w-auto shadow-lg ring-2 ring-transparent focus:ring-brand-light"
          >
            English
          </button>
          <button 
            onClick={() => selectLanguage('es')} 
            className="btn-primary text-xl px-10 py-4 w-full sm:w-auto shadow-lg ring-2 ring-transparent focus:ring-brand-light"
          >
            Español
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20 text-slate-300 text-sm space-y-2">
          <p>Townhouse for Rent • $2,800 per month</p>
          <p>Townhouse en alquiler • $2,800 mensuales</p>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelection;